export const createTitle = (title: string, stepName: string) => {
  const titleEl = document.createElement('div');
  titleEl.classList.add('title');
  titleEl.classList.add(`title-${stepName}`);
  titleEl.textContent = title;

  return titleEl;
};
